import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../environments/environment';
import { AuthService } from '../../shared/services/auth.service';

const API_URLS = [
  environment.apiUrl,
  environment.catalogoApiUrl,
  environment.prenotazioneApiUrl,
  environment.indirizzoApiUrl,
  environment.mobileAppBeApiUrl,
  environment.anaWikiApiUrl,
];

export const serviceApiInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.token();

  const isAuthTokenRequest = req.url.includes('/auth/clienti-fo-token');
  const isOwnApiRequest = API_URLS.some(apiUrl => req.url.includes(apiUrl));

  if (token && isOwnApiRequest && !isAuthTokenRequest) {
    const authReq = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token}`)
    });

    return next(authReq);
  }

  return next(req);
};

